import React, {useContext, useState} from "react";
import {Button, CardHeader, TextField} from "@material-ui/core";
// import "../App.css";
import Error from "../Error";
// import Balance from "../Balance";
import Loading from "../Loading";

import {store} from "../store.js";

function Lookup() {
    const [card, setCard] = useState("");
    const [error, setError] = useState(false);
    const [statusMsg, setStatusMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const globalState = useContext(store);
    const {setState: setGlobalState} = globalState;
    // const { var } = globalState.state;

    const updateTextField = e => {
        const value = e.target.value;
        setCard(value);
    };

    const submit = async e => {
        e.preventDefault();
        setStatusMsg("");
        setError(false);
        setLoading(true);

        if (card === "") {
            setError("cardNumber");
            setLoading(false);
            setStatusMsg("Card number is required");
            return;
        }

        let url = 'https://www.firsttowndowntown.org/giftcards/index.php/balance';
        if (globalState.state.env === 'dev') {
            //let url = "https://www.firsttowndowntown.org/giftcards/index.php/balance";
            url = "http://localhost:9000/balance";
        }

        if (card) {
            url = url + `/${card}`;
        }

        const result = await fetch(url).then(resp => resp.json());

        if (result.data.status === "error") {
            setError("cardNumber");
            setStatusMsg("Invalid Card Number");
            setLoading(false);
            setGlobalState({_path: "account.number", _value: false});
            setGlobalState({_path: "account.balance", _value: "--"});
            return;
        }

        if (result.data.status === "success") {
            setLoading(false);
            setGlobalState({_path: "progress", _value: "amount"});
            setGlobalState({_path: "account.number", _value: card});
            setGlobalState({_path: "account.balance", _value: result.data.balance});
        }
    };

    let cardNumberError = false;
    if (error === "cardNumber") {
        cardNumberError = true;
    }

    return (
        <React.Fragment>
            <CardHeader
                title="Account Information"
                subheader="Enter your account information to begin."
            />
            <form onSubmit={submit}>
                <TextField
                    required
                    type="text"
                    onChange={updateTextField}
                    label="Card Number"
                    id="card-number"
                    error={cardNumberError}
                />
                {error === "cardNumber" &&
                statusMsg &&
                <Error>
                    {statusMsg}
                </Error>}
                {error === false && <div style={{height: "15px"}}/>}
                <div className="action">
                    <Button className="submit" variant="contained" onClick={submit}>
                        Lookup
                    </Button>
                    {loading === true && <Loading/>}
                </div>
            </form>
        </React.Fragment>
    );
}

export default Lookup;
